import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useCommonFetch from "../../../hooks/useCommonFetch";
import {
  createLeaveType,
  getLeaveTypeList,
  updateLeaveType,
} from "../../../services/workspace/leaveType.service";
import { deleteDepartment } from "../../../services/workspace/department.service";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../components/table/table";
import CommonModal from "../../components/modals/commonModel";
import CommonForm from "../../components/form/form";
import BottomDrawer from "../common/drawer/bottomDrawer";
import { MdCalendarToday } from "react-icons/md";
import img from "../../assets/images/profile-sample.jpg";
import CustomTab, { TabContainer } from "../../components/tabs/customTabs";
import { FaCheck } from "react-icons/fa";
import { Icons } from "../../../utils/icons";
import DefaultButton from "../../components/buttons/defaultButton";
import DefaultBadge from "../../components/badge/defaultBadge";

const Leads = () => {
  const navigate = useNavigate();

  const [isEditValue, setIsEditValue] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [assignRecord, setAssignRecord] = useState(null);

  const [isOpenSheet, setIsOpenSheet] = useState(false);

  const handleClose = () => setIsOpenSheet(false);
  const handleView = () => setIsOpenSheet(true);

  const actions_type = {
    VIEW: "VIEW",
    DELETE: "DELETE",
    ADD_EDIT: "ADD_EDIT",
  };

  const breadcrumbs = [{ label: "Leads", path: "" }];

  const TableHeaderData = [
    { label: "Applicant Name", key: "name" },
    { label: "Phone", key: "phone" },
    { label: "City", key: "city" },
    { label: "Created Date", key: "created_date" },
    { label: "Source", key: "source" },
    { label: "Assigned to", key: "assign_to" },
    { label: "Status", key: "status" },
  ];

  const {
    data: tableData,
    total: totalData,
    currentPage,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useCommonFetch(getLeaveTypeList, {
    errorMessage: "Failed to fetch leave data!",
    debounceDelay: 500,
    dataTransformer: (data) => {
      const dummyData = [
        {
          id: "12234",
          name: "John Doe",
          phone: "8473847343",
          city: "Engineer",
          created_date: "2025-08-01",
          source: "sadf",
          assign_to: "dcsf",
          status: true,
        },
        {
          id: "122434",
          name: "Jane Smith",
          phone: "7482374383",
          city: "ebhdmc",
          created_date: "2025-08-05",
          source: "dsf",
          assign_to: "fdsc",
          status: false,
        },
      ];

      const finalData =
        Array.isArray(data) && data.length > 0 ? data : dummyData;

      const transformedData = finalData.map((item) => ({
        id: item.id,
        name: { data: item.name, variant: "checkbox" },
        phone: { data: item.phone, variant: "text" },
        city: { data: item.city, variant: "text" },
        created_date: { data: item.created_date, variant: "text" },
        source: { data: item.source, variant: "text" },
        assign_to: { data: item.assign_to, variant: "text" },
        status: {
          data: item.status ? "Approved" : "Pending",
          variant: "status",
        },
      }));

      const actionButton = {
        view: (item) => handleView(item),
        delete: (item) =>
          handleDelete(item.id.data, deleteDepartment, {
            successMessage: "Department deleted successfully!",
            errorMessage: "Failed to delete department!",
          }),
        edit: (item) => {
          setIsEditValue(item);
          openModal(item, actions_type.ADD_EDIT);
        },
        assign: (item) => assignUser(item),
      };

      return { data: transformedData, action: actionButton };
    },
  });

  const assignFields = [
    {
      name: "branch",
      label: "Select Branch",
      type: "select",
      required: true,
      placeholder: "Select branch",
    },
    {
      name: "user",
      label: "Select User",
      type: "select",
      required: true,
      placeholder: "Select user",
    },
    {
      name: "description",
      label: "Description",
      type: "textarea",
      placeholder: "Write here...",
    },
  ];

  const handleAssignSubmit = async (values, { setSubmitting, resetForm }) => {
 
    setSubmitting(false);
    resetForm();
    setShowAssignModal(false);
    setAssignRecord(null);
  };

  const assignUser = (item) => {
    setAssignRecord(item);
    setShowAssignModal(true);
  };

  const handleAssignCancel = () => {
    setAssignRecord(null);
    setShowAssignModal(false);
  };

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => navigate("/leads/add")}
        filter
        shorting
        import_button
        export_button
        onClickFilter={() => {}}
        onClickShorting={() => {}}
        onClickImport={() => {}}
        onClickExport={() => {}}
        breadcrumbs={breadcrumbs}
      />

      <CommonTable
        TableHeaderData={TableHeaderData}
        tabledata={tableData.data}
        currentPage={currentPage}
        totalData={totalData}
        setCurrentPage={handlePageChange}
        loading={false}
        action={tableData.action}
        selectionKey="id"
        selectedRows={selectedIds}
        onSelectionChange={setSelectedIds}
        assignUser={assignUser}
        handleClose={handleAssignCancel}
      />

      <CommonModal
        modalSize="lg"
        headerTitle="Assign User"
        onClose={handleAssignCancel}
        show={showAssignModal}
      >
        <CommonForm
          fields={assignFields}
          initialData={{}}
          onSubmit={handleAssignSubmit}
          submitButtonText="Assign"
          columnsPerRow={1}
          gap="gap-4"
          rowClassName=""
          fieldClassName="bg-white p-3 rounded shadow-sm"
        />
      </CommonModal>

      <BottomDrawer
        isOpen={isOpenSheet}
        setIsOpen={handleClose}
        title="Lead Details"
        classNames="!w-[600px]"
        position="right"
      >
        <LeadDetail />
      </BottomDrawer>
    </div>
  );
};

const LeadDetail = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const tabs = [
    {
      id: "tab1",
      label: "Overview",
      content: (
        <div className="overflow-x-auto">
          <div className="flex flex-col gap-2 px-4">
            <Overview />
          </div>
        </div>
      ),
    },
    {
      id: "tab2",
      label: "Activities",
      content: (
        <div className="flex flex-col gap-2 overflow-auto ">
          <LeadDetailsTimeline />
        </div>
      ),
    },
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    navigate(`?tab=${tabId}`);
  };

  useEffect(() => {
    const tabFromUrl = searchParams.get("tab");
    if (tabFromUrl !== null && tabFromUrl !== undefined) {
      setActiveTab(tabFromUrl);
    }
  }, [searchParams]);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4 items-center itmes-start border-b pb-4 border-gray-200">
        <div className="overflow-hidden w-20 rounded-full">
          <img src={img} alt="profile" className="object-cover" />
        </div>
        <div className="w-full">
          <h3 className="text-2xl font-bold text-primary-900">Rahul Madhur</h3>
          <div className="flex flex-row justify-between items-center">
            <p className="text-gray-600 text-sm">
              Email: <span className="text-primary-800">test@gmail.com</span>
            </p>
            <p className="text-gray-600 text-sm">
              Phone: <span className="text-primary-800">+91 84729 72479</span>
            </p>
          </div>
        </div>
      </div>

      <div>
        <CustomTab
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
          className={"!bg-light"}
        />
        <TabContainer tabs={tabs} activeTab={activeTab} />
      </div>
    </div>
  );
};

const Overview = () => {
  const leadData = {};
  const basicDetails = [
    { label: "Date Of Birth", value: leadData?.dob, icon: <MdCalendarToday /> },
    { label: "Gender", value: leadData?.gender },
    { label: "Father Name", value: leadData?.fatherName },
    { label: "Mother Name", value: leadData?.motherName },
    { label: "Marital Status", value: leadData?.maritalStatus },
    { label: "Nationality", value: leadData?.nationality },
    { label: "City", value: leadData?.city },
    { label: "State", value: leadData?.state },
    { label: "Pincode", value: leadData?.pincode },
  ];
  const fullWidthDetails = [{ label: "Address", value: leadData?.address }];
  const loanDetails = [
    { label: "Loan Type", value: leadData?.loanType },
    {
      label: "Loan Amount",
      value: leadData?.loanAmount ? `₹${leadData.loanAmount}` : "",
    },
    { label: "Tenure Range (months)", value: leadData?.tenure },
    { label: "Occupation Type", value: leadData?.occupationType },
    { label: "Collateral Applicable", value: leadData?.collateralApplicable },
    { label: "Collateral Type", value: leadData?.collateralType },
  ];

  const loanFullWidthDetails = [
    { label: "Collateral Address", value: leadData?.collateralAddress },
  ];
  return (
    <div>
      <div className="">
        <h4 className="text-lg font-semibold text-primary-900 mb-4">
          Basic Details
        </h4>
        <div className="grid grid-cols-2 gap-2 text-sm">
          {basicDetails.map((item, index) => (
            <DetailItem
              key={index}
              label={item.label}
              value={item.value}
              icon={item.icon}
            />
          ))}
          {fullWidthDetails.map((item, index) => (
            <div key={index} className="col-span-2">
              <DetailItem label={item.label} value={item.value} />
            </div>
          ))}
        </div>
      </div>

      <div className="">
        <h4 className="text-lg font-semibold text-primary-900 mb-4">
          Loan Details
        </h4>
        <div className="grid grid-cols-2 gap-2 text-sm">
          {loanDetails.map((item, index) => (
            <DetailItem key={index} label={item.label} value={item.value} />
          ))}
          {loanFullWidthDetails.map((item, index) => (
            <div key={index} className="col-span-2">
              <DetailItem label={item.label} value={item.value} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const LeadDetailsTimeline = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row justify-between items-center pb-4 border-b">
        <span className="flex flex-row gap-2">
          <p className="text-textLight ">Status : </p>
          <DefaultBadge />
        </span>
        <span className="flex flex-row gap-2">
          <p className="text-textLight ">Last Activity: </p>
          <p className="text-theme">28-07-2025 | 10:00 AM</p>
        </span>
      </div>
      <h1 className="text-theme text-md font-semibold">Latest Activities</h1>
      <div className="bg-white p-6 border text-sm">
        <div className="flex">
          {/* Timeline column */}
          <div className="relative w-6 flex flex-col items-center justify-between">
            {/* Vertical Line */}
            <div className="absolute top-3 bottom-0 w-px bg-gray-200 z-0" />

            {/* Dot 1 */}
            <div className="w-6 h-6 rounded-full bg-[#2D3E91] text-white flex items-center justify-center z-10">
              <FaCheck size={10} />
            </div>

            {/* Spacer for spacing */}
            <div className="h-8" />

            {/* Dot 2 */}
            <div className="w-6 h-6 rounded-full border-2 border-[#2D3E91] bg-white flex items-center justify-center z-10">
              <div className="w-2.5 h-2.5 rounded-full bg-[#2D3E91]" />
            </div>

            <div className="h-8" />

            {/* Dot 3 */}
            <div className="w-6 h-6 rounded-full border-2 border-gray-300 bg-white z-10" />
          </div>

          {/* Content column */}
          <div className="ml-4 flex-1 space-y-10">
            {/* Step 1 */}
            <div>
              <div className="text-[#1D2453] font-bold">Lead Received</div>
              <div className="text-gray-500 text-sm">28-07-2025</div>
            </div>

            {/* Step 2 */}
            <div>
              <div className="text-[#1D2453] font-bold">
                Lead assigned to Sales Agent{" "}
                <span className="text-[#2D3E91]">Pooja Mehra</span>
              </div>
              <div className="text-gray-500 text-sm">28-07-2025</div>

              {/* Status transition */}
              <div className="flex items-center gap-2 mt-2">
                <span className="text-[#2D3E91] text-sm flex items-center gap-1">
                  <span className="w-2 h-2 rounded-full bg-[#2D3E91]" />
                  New
                </span>
                <span className="text-gray-400">→</span>
                <span className="text-[#F7941D] text-sm flex items-center gap-1">
                  <span className="w-2 h-2 rounded-full bg-[#F7941D]" />
                  In Process
                </span>
              </div>
            </div>

            {/* Step 3 */}
            <div>
              <div className="text-gray-400 font-bold">Lead Converted</div>
              <div className="text-gray-400 text-sm">Not Yet</div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-theme text-md font-semibold">Notes</h1>
        <DefaultButton variant="outline" name={"Add Note"} icon={Icons.ADD} />
      </div>
      <div className="border">
        <div className=" flex flex-row justify-between items-center p-4">
          <div className="flex flex-row gap-2 items-center justify-between">
            <span className="flex flexCenter w-8 h-8 rounded-full bg-light text-md">
              {Icons.DOCUMENT}
            </span>
            <span className="text-cs font-medium text-theme">
              <h1>Note By Pooja Mehra</h1>
            </span>
          </div>
          <div className="flex flex-row items-center justify-between text-textLight gap-2">
            <span>
              <h1>28-07-2025</h1>
            </span>
            <div className="w-[1px] h-[16px] bg-borderColor"></div>
            <span>
              <h1>10:10 AM</h1>
            </span>
          </div>
        </div>
        <div className="border-t p-4 text-theme font-light">
          Spoke with the customer. They are interested in a personal loan of
          ₹3,00,000. Documents to be shared by tomorrow.
        </div>
      </div>
    </div>
  );
};

const DetailItem = ({ label, value, icon }) => (
  <div className="p-0 m-0">
    <p className="font-medium text-gray-500 flex items-center gap-1">
      {icon} {label}
    </p>
    <p className="text-primary-900 font-semibold">{value || "-"}</p>
  </div>
);

export default Leads;
